module.exports = __webpack_public_path__ + "static/media/iconeinjection.dced3983.png";